import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SaleOrder from '../entities/sale-order'
import SaleOrderDetail from '../entities/sale-order-detail'
import SaleOrderLineDetail from '../entities/sale-oder-line-detail'
import SoStatus from '../entities/soStatus'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Invoice from '../entities/invoice'
import ShippingLabel from '../entities/shipping-label'
import Ref from '../entities/ref'
import SalesOrderForSelect from '../entities/sales-orders/sales-order-for-select'
import appconst from '@/lib/appconst'
interface SaleOrderState extends ListState<SaleOrder> {
    soStatuses: Array<SoStatus>
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineList: Array<SaleOrderLineDetail>,
    lineLoading: boolean,
    viewSaleOrder: SaleOrder,
    invoice : Invoice,
    shippingLabel : ShippingLabel,
    bizTypes : Array<Ref>,
    outboundModes :Array<Ref>
}
class SaleOrderModule extends ListModule<SaleOrderState, any, SaleOrder>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SaleOrder>(),
        loading: false,
        soStatuses: new Array<SoStatus>(),
        lineTotalCount:0,
        lineCurrentPage:1,
        linePageSize:10,
        lineLoading:false,
        lineList : new Array<SaleOrderLineDetail>(),
        viewSaleOrder: new SaleOrder(),
        invoice : new Invoice(),
        shippingLabel : new ShippingLabel(),
        bizTypes: new Array<Ref>(),
        outboundModes:new Array<Ref>()
    }
    actions = {
        async getAll(context: ActionContext<SaleOrderState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/So/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<SaleOrder>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllSaleOrderLine(context: ActionContext<SaleOrderState, any>, payload: any) {
            context.state.lineLoading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoLine/GetAll', { params: payload.data });
            context.state.lineLoading = false;
            const page = result as PageResult<SaleOrderLineDetail>;
            context.state.lineTotalCount = page.totalCount;
            context.state.lineList = page.items;
        },
        async get(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/GetDetail?Id='+payload.data.id );
            return reponse.data.result as SaleOrderDetail;
        },
        async getByCode(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/GetDetailByCode?code='+payload.data.code );
            return reponse.data.result as SaleOrderDetail;
        },
        async create(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.post('/api/services/app/So/Create', payload.data);
        },
        async update(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.put('/api/services/app/So/Update', payload.data);
        },
        async updateSoCommonInfomation(context: ActionContext<SaleOrderState, any>, payload: any) {
            const {data:{result} } = await Ajax.put('/api/services/app/So/UpdateSoCommonInfomation', payload.data);
            return result;
        },
        async delete(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.delete('/api/services/app/So/Delete?Id=' + payload.data.id);
        },
        async getSoStatusesForSelect(context: ActionContext<SaleOrderState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/So/GetSoStatusForSelect', { params : payload.data });
            context.state.soStatuses = result.items as SoStatus[];
        },
        async getBizTypes(context: ActionContext<SaleOrderState, any>) {
            const {data:{result} } = await Ajax.get('/api/services/app/So/GetBizTypes');
            context.state.bizTypes = result.items as Ref[];
        },
        async getOutboundModes(context: ActionContext<SaleOrderState, any>) {
            const {data:{result} } = await Ajax.get('/api/services/app/So/GetOutboundMode');
            context.state.outboundModes = result.items as Ref[];
        },
        async getOutboundModesForSelect(context: ActionContext<SaleOrderState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/So/GetOutboundMode', { params : payload.data });
            return result.items as Ref[];
        },
        async getInvoice(context: ActionContext<SaleOrderState, any>, payload: any) {
            var url = `/api/services/app/invoice/${payload.data.code}/${payload.data.contactNumber}`; 
            const {data:{result} } = await Ajax.get(url);
            context.state.invoice = result as Invoice;
        },
        async getInvoiceTransfer(context: ActionContext<SaleOrderState, any>, payload: any) {
            var url = `/api/services/app/invoice-transfer/${payload.data.code}`; 
            const {data:{result} } = await Ajax.get(url);
            context.state.invoice = result as Invoice;
        },
        async getShippingLabel(context: ActionContext<SaleOrderState, any>, payload: any) {
            var url = "/api/services/app/So/GetShippingLabelOfSo/" + payload.data.soCode + "/" + payload.data.packageNo;
            const {data:{result} } = await Ajax.get(url);
            context.state.shippingLabel = result as ShippingLabel;
        },
        async getShippingLabelOfGroup(context: ActionContext<SaleOrderState, any>, payload: any) {
            var url = "/api/services/app/So/GetShippingLabelOfGroup/" + payload.data.groupPackageNo;
            const {data:{result} } = await Ajax.get(url);
            context.state.shippingLabel = result as ShippingLabel;
        },
        async adjustAllocatingQty(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.put('/api/services/app/SoLine/AdjustAllocatingQty', payload.data);
        },
        async searchSoForReturn(context:ActionContext<SaleOrderState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/So/SearchSoForReturn/'+payload.data.clientCode+'/'+payload.data.keyWord);
            return result.items  as SalesOrderForSelect[];
        },
        async getSoForReturn(context:ActionContext<SaleOrderState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/So/GetSoForReturn',{ params : payload.data });
            return result;
        },
        async cancel(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.post('/api/services/app/So/Cancel/', payload.data);
        },
        async adjustConfirmPackingQty(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.put('/api/services/app/SoLine/AdjustConfirmPackingQty', payload.data);
        },
        async getSoExtensionInfos(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/GetSoExtensionInfos?id='+payload.data );
            return reponse.data.result;
        },
        async getSoStatusTrackings(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/GetSoStatusTrackings?id='+payload.data );
            return reponse.data.result;
        },
        async checkProductInventories(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/CheckSoLineInventories',{ params : payload.data } );
            return reponse.data.result;
        },
        async finish(context: ActionContext<SaleOrderState, any>, payload: any) {
            await Ajax.put(`/api/services/app/So/${payload.data.id}/finish`);
        },
        async getSalesOrderLineForCreate(context: ActionContext<SaleOrderState, any>, payload: any) {
            let reponse=await Ajax.get('/api/services/app/So/GetSoLinesForCreate?soRequestId='+payload.data.soRequestId );
            return reponse.data.result;
        },
        async searchSoForShip(context:ActionContext<SaleOrderState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/So/SearchSoForShipPo/'+payload.data.keyWord);
            return result.items  as SalesOrderForSelect[];
        },
        async getSoForShip(context:ActionContext<SaleOrderState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/So/GetSoForShipPo/'+payload.data.id);
            return result;
        }
    };
    mutations = {
        setCurrentPage(state: SaleOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SaleOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setLineCurrentPage(state: SaleOrderState, page: number) {
            state.lineCurrentPage = page;
        },
        setLinePageSize(state: SaleOrderState, pagesize: number) {
            state.linePageSize = pagesize;
        },
        refreshListData(state: SaleOrderState)
        {
            state.list = new Array<SaleOrder>();
        },
        view(state: SaleOrderState, saleOrder:SaleOrder) {
            state.viewSaleOrder = saleOrder;
        }
    }
}
const saleOrderModule = new SaleOrderModule();
export default saleOrderModule;